<mat-card appearance="outlined" style="padding-top: 10px">
  <form name="form" #f="ngForm" (ngSubmit)="f.form.valid && SaveMaintenance(f)">
    <div class="row">
      <div class="col-md-4">
        <mat-form-field class="custom-form-field">
          <mat-label>Select an option</mat-label>
          <mat-select
            [(value)]="selected"
            (selectionChange)="maintenanceDropdown(); resetform(f)"
            class="custom-select-option"
          >
            <mat-option value="InstituteVal">Institute</mat-option>
            <mat-option value="BoardVal">Board/University</mat-option>
            <mat-option value="OrganisationVal">Organisation</mat-option>
            <mat-option value="CityVal">City</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-4" *ngIf="selected === 'InstituteVal'">
        <mat-form-field class="custom-form-field">
          <input
            matInput
            placeholder="City"
            aria-label="State"
            [matAutocomplete]="auto"
            [formControl]="searchCityCtrl"
            required
          />
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngIf="isLoading" class="is-loading">Loading...</mat-option>
            <ng-container *ngIf="!isLoading">
              <mat-option
                *ngFor="let cityData of filteredCity"
                [value]="cityData.city_state_country"
                (onSelectionChange)="onCityChange(cityData.city_id)"
              >
                <span
                  ><strong>{{ cityData.city_state_country }}</strong></span
                >
              </mat-option>
            </ng-container>
          </mat-autocomplete>
          <mat-error *ngIf="f.submitted && searchCityCtrl.errors?.required"> Please enter City </mat-error>
          <mat-error *ngIf="f.submitted && searchCityCtrl.status === 'INVALID' && !searchCityCtrl.errors?.required">
            Please select the value from the list
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-4" *ngIf="selected === 'InstituteVal'">
        <mat-form-field class="custom-form-field">
          <input
            matInput
            placeholder="Institute"
            class="form-control"
            name="maintenanceTxt"
            #institute="ngModel"
            [(ngModel)]="maintenanceTxt"
            pattern="^[a-zA-Z ]+$"
            required
          />
        </mat-form-field>
        <div *ngIf="institute.invalid && (institute.dirty || f.submitted)" class="invalid-fromdata">
          <div *ngIf="institute.errors?.required">Please enter Institute</div>
          <div *ngIf="institute.errors?.pattern">Please enter valid Institute</div>
        </div>
      </div>
      <div class="col-md-4" *ngIf="selected === 'BoardVal'">
        <mat-form-field class="custom-form-field">
          <input
            matInput
            placeholder="Board/University"
            class="form-control"
            name="maintenanceTxt"
            #board="ngModel"
            [(ngModel)]="maintenanceTxt"
            pattern="^[a-zA-Z ]+$"
            required
          />
        </mat-form-field>
        <div *ngIf="board.invalid && (board.dirty || f.submitted)" class="invalid-fromdata">
          <div *ngIf="board.errors?.required">Please enter Board/University</div>
          <div *ngIf="board.errors?.pattern">Please enter valid Board/University</div>
        </div>
      </div>
      <div class="col-md-4" *ngIf="selected === 'OrganisationVal'">
        <mat-form-field class="custom-form-field">
          <input
            matInput
            placeholder="Organisation"
            class="form-control"
            name="maintenanceTxt"
            #organizantion="ngModel"
            [(ngModel)]="maintenanceTxt"
            required
          />
        </mat-form-field>
        <div *ngIf="f.submitted && organizantion.invalid" class="invalid-fromdata">
          <div *ngIf="organizantion.errors.required">Please enter Organisation</div>
        </div>
      </div>
      <div class="col-md-4" *ngIf="selected === 'CityVal'">
        <mat-form-field class="custom-form-field">
          <input
            matInput
            placeholder="City"
            class="form-control"
            name="maintenanceTxt"
            #city="ngModel"
            [(ngModel)]="maintenanceTxt"
            required
          />
        </mat-form-field>
        <div *ngIf="f.submitted && city.invalid" class="invalid-fromdata">
          <div *ngIf="city.errors.required">Please enter City</div>
        </div>
      </div>
      <div class="col-md-4" *ngIf="selected === 'DegreeVal'">
        <mat-form-field class="custom-form-field">
          <input
            matInput
            placeholder="Degree"
            name="maintenanceTxt"
            #degree="ngModel"
            [(ngModel)]="maintenanceTxt"
            required
          />
        </mat-form-field>
        <div *ngIf="f.submitted && degree.invalid" class="invalid-fromdata">
          <div *ngIf="degree.errors.required">Please enter Degree</div>
        </div>
      </div>
      <div class="col-md-4" *ngIf="selected === 'SpecializationVal'">
        <mat-form-field class="custom-form-field">
          <input
            matInput
            placeholder="Specialization"
            class="form-control"
            name="maintenanceTxt"
            #specialization="ngModel"
            [(ngModel)]="maintenanceTxt"
            required
          />
        </mat-form-field>
        <div *ngIf="f.submitted && specialization.invalid" class="invalid-fromdata">
          <div *ngIf="specialization.errors.required">Please enter Specialization</div>
        </div>
      </div>
      <div class="col-md-4" *ngIf="selected === 'DegreeVal'">
        <mat-form-field class="custom-form-field">
          <input
            matInput
            placeholder="EducationType"
            aria-label="EducationType"
            [matAutocomplete]="auto"
            [formControl]="eduCtrl"
            required
          />
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngIf="isLoading" class="is-loading">Loading...</mat-option>
            <ng-container *ngIf="!isLoading">
              <mat-option
                *ngFor="let edu of filteredEdu | async"
                [value]="edu.educationTypeName"
                (onSelectionChange)="onEduChange($event)"
              >
                <span
                  ><strong>{{ edu.educationTypeName }}</strong></span
                >
              </mat-option>
            </ng-container>
          </mat-autocomplete>
          <mat-error *ngIf="f.submitted && eduCtrl.errors?.required"> Please enter Education type </mat-error>
          <mat-error *ngIf="f.submitted && eduCtrl.status === 'INVALID' && !eduCtrl.errors?.required">
            Please select the value from the list
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-4" *ngIf="selected === 'CityVal'">
        <mat-form-field class="custom-form-field">
          <input
            matInput
            placeholder="Country"
            aria-label="Country"
            [matAutocomplete]="auto"
            [formControl]="countryCtrl"
            required
          />
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngIf="isLoading" class="is-loading">Loading...</mat-option>
            <ng-container *ngIf="!isLoading">
              <mat-option
                *ngFor="let country of filteredCountry | async"
                [value]="country.countryName"
                (onSelectionChange)="onCountryChange($event)"
              >
                <span
                  ><strong>{{ country.countryName }}</strong></span
                >
              </mat-option>
            </ng-container>
          </mat-autocomplete>
          <mat-error *ngIf="f.submitted && countryCtrl.errors?.required"> Please enter Country </mat-error>
          <mat-error *ngIf="f.submitted && countryCtrl.status === 'INVALID' && !countryCtrl.errors?.required">
            Please select the value from the list
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-4" *ngIf="selected === 'CityVal'">
        <mat-form-field class="custom-form-field">
          <input
            matInput
            placeholder="State"
            aria-label="State"
            [matAutocomplete]="auto"
            [formControl]="stateCtrl"
            [readonly]="isDisabled"
            required
          />
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngIf="isLoading" class="is-loading">Loading...</mat-option>
            <ng-container *ngIf="!isLoading">
              <mat-option
                *ngFor="let state of filteredStates"
                [value]="state.value"
                (onSelectionChange)="onStateChange(state.key)"
              >
                <span
                  ><strong>{{ state.value }}</strong></span
                >
              </mat-option>
            </ng-container>
          </mat-autocomplete>
          <mat-error *ngIf="f.submitted && stateCtrl.errors?.required"> Please enter State </mat-error>
          <mat-error *ngIf="f.submitted && stateCtrl.status === 'INVALID' && !stateCtrl.errors?.required">
            Please select the value from the list
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div
      class="row nomarLR padTB16"
      *ngIf="
        selected === 'OrganisationVal' ||
        selected === 'InstituteVal' ||
        selected === 'BoardVal' ||
        selected === 'CityVal' ||
        selected === 'DegreeVal' ||
        selected === 'SpecializationVal'
      "
    >
      <div class="col-4" id="saveBtn">
        <button mat-flat-button class="primary-btn" type="submit">Save</button>
      </div>
    </div>
  </form>
</mat-card>
